import { render, staticRenderFns } from "./event-item-minimal.vue?vue&type=template&id=65f716e6&"
import script from "./event-item-minimal.vue?vue&type=script&lang=js&"
export * from "./event-item-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports